<template>
  <Wizard
    class   = "wizard"
    icon    = "mdi-file-video"
  >
    <div class="open-file-wizard">

      <!-- Message -->
      <span class="message text-h5">
        <v-btn
          color   = "primary"
          class   = "text-h5 text-none px-1 mr-1"
          text
          @click  = "onOpenFileBrowser()"
        >
          Browse
        </v-btn>

        <span v-if="recentFiles.length > 0"
              class="text"
        > or select a recently opened file: </span>
        <span v-else
              class="text"
        > to select a file. </span>
      </span>

      <!-- Partial List / Quick Select -->
      <v-list 
        v-if      = "shortFilesList.length > 0"
        dense
        max-width = "400px"
      >
        <v-divider></v-divider>

        <v-list-item
          v-for   = "(file, index) in shortFilesList"
          :key    = "index"
          @click  = "onOpenFile(file.path, file.open ? 'growing' : 'video')"
        >
          <v-list-item-content>
            <v-list-item-title>{{ file.filename }} </v-list-item-title>
            <v-list-item-subtitle class = "subtitle_width_fix">{{ file.folder }}</v-list-item-subtitle>
            <v-list-item-subtitle v-if = "file.open"> Opened as Growing File </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
      </v-list>

      <div v-if="recentFiles.length > 0"
           class="text-right"
      >
        <!-- Full List -->
        <v-menu left
                top
                min-width="400px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color   = "primary"
              text
              small
              v-bind  = "attrs"
              v-on    = "on"
            >
              More
            </v-btn>
          </template>

          <v-list 
            dense
            max-width = "400px"
          >
            <v-list-item
              v-for   = "(file, index) in recentFiles"
              :key    = "index"
              @click  = "onOpenFile(file.path, file.open ? 'growing' : 'video')"
            >
              <v-list-item-content>
                <v-list-item-title>{{ file.filename }}</v-list-item-title>
                <v-list-item-subtitle class="subtitle_width_fix">{{ file.folder }}</v-list-item-subtitle>
                <v-list-item-subtitle v-if="file.open"> Opened as Growing File </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
  </Wizard>
</template>

<script lang="js">

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import Wizard from '../Wizard';
import { toRecentFileList } from '@/store/utilities/history.utils';
import { LOAD_VIDEO } from '@/utils/action-types';
import { SET_FILE_BROWSER_IS_OPEN } from '@/utils/mutation-types';

// #endregion Imports

// #region Constants

const SHORT_LIST_LENGTH = 3;

// #endregion Constants

export default {

  // #region Properties

  name:       'SelectFileWizard',
  components: {
    Wizard
  },
  computed: {
    ...mapState([
      'history'
    ]),
    shortFilesList() {
      return this.recentFiles.slice(0, SHORT_LIST_LENGTH);
    },
    recentFiles() {
      return (this.history.history ? toRecentFileList(this.history.history) : []);
    }
  },

  // #endregion Properties

  // #region Events

  methods: {

    onOpenFileBrowser() {
      this.$store.commit(SET_FILE_BROWSER_IS_OPEN, true);
    },

    onOpenFile(path, type) {
      this.$store.dispatch(
        LOAD_VIDEO,
        {
          videoPath:  path,
          audioPaths: [],
          open:       type == 'growing' ? true : false
        }
      );
    }

  }

  // #endregion Events

}
</script>

<style lang="scss" scoped>
@import '../../../../styles/colors.scss';

.wizard {
  .open-file-wizard {
    .message {
      display: flex;
      align-items: center;

      // Makes the text align with the button.
      .text {
        padding-top: 1px;
      }
    }

    .v-list-item__title {
      color: $label-color;
    }

    .v-list-item__subtitle {
      color: $darker-label-color;
    }
  }
}

.v-list-item__title {
  white-space: normal;
  word-wrap: break-word;
}

</style>
